import { openAppPathInNewTab } from './openAppPathInNewTab';

const MIDDLE_CLICK_DEDUPE_MS = 400;
let lastMiddleClickOpenedAt = 0;
let lastMiddleClickOpenedPath = '';

export const isExternalHref = (href) => {
  if (!href) return true;
  const trimmed = String(href).trim();
  const scriptScheme = ['java', 'script:'].join('');
  if (!trimmed || trimmed === '#' || trimmed.startsWith('#')) return true;
  if (
    trimmed.startsWith('mailto:')
    || trimmed.startsWith('tel:')
    || trimmed.toLowerCase().startsWith(scriptScheme)
  ) {
    return true;
  }
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
    try {
      const url = new URL(trimmed);
      return url.origin !== window.location.origin;
    } catch {
      return true;
    }
  }
  return false;
};

export const normalizeAppPath = (href) => {
  if (!href) return null;
  const trimmed = String(href).trim();
  if (!trimmed || trimmed === '#') return null;
  if (trimmed.startsWith('/')) return trimmed;
  try {
    const url = new URL(trimmed, window.location.origin);
    if (url.origin !== window.location.origin) return null;
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
};

export const getAppPathFromEventTarget = (target) => {
  if (!target?.closest) return null;

  const carrier = target.closest('a[href], [data-app-path], [data-sidebar-path]');
  if (!carrier) return null;

  if (carrier.tagName === 'A') {
    const href = carrier.getAttribute('href');
    if (isExternalHref(href)) return null;
    return normalizeAppPath(href);
  }

  const dataPath = carrier.getAttribute('data-app-path') || carrier.getAttribute('data-sidebar-path');
  if (!dataPath) return null;
  return normalizeAppPath(dataPath.startsWith('/') ? dataPath : `/${dataPath}`);
};

const openAppPathOnce = (path) => {
  const now = Date.now();
  if (
    path === lastMiddleClickOpenedPath
    && now - lastMiddleClickOpenedAt < MIDDLE_CLICK_DEDUPE_MS
  ) {
    return;
  }
  lastMiddleClickOpenedAt = now;
  lastMiddleClickOpenedPath = path;
  openAppPathInNewTab(path);
};

export const handleMiddleClickOpenAppPath = (event) => {
  if (event.button !== 1) return false;
  if (event.defaultPrevented) return false;

  const path = getAppPathFromEventTarget(event.target);
  if (!path) return false;

  openAppPathOnce(path);
  event.preventDefault();
  event.stopPropagation();
  return true;
};

export const attachSpaMiddleClickLinks = () => {
  const onMiddleClick = (event) => {
    handleMiddleClickOpenAppPath(event);
  };

  document.addEventListener('auxclick', onMiddleClick, true);
  document.addEventListener('mousedown', onMiddleClick, true);

  return () => {
    document.removeEventListener('auxclick', onMiddleClick, true);
    document.removeEventListener('mousedown', onMiddleClick, true);
  };
};

export const isPrimarySpaNavigation = (event) =>
  event.button === 0
  && !event.metaKey
  && !event.ctrlKey
  && !event.shiftKey
  && !event.altKey;

export const createSpaLinkClickHandler = (navigate, path) => (event) => {
  if (!isPrimarySpaNavigation(event)) return;
  event.preventDefault();
  if (typeof navigate === 'function' && path) {
    navigate(path);
  }
};
